import { useRef, useState } from 'react';

import { useParams } from 'react-router';

import { Grid } from '@mui/material';
import { GridRowId } from '@mui/x-data-grid-pro';
import { FormikProvider, useFormik } from 'formik';

import { DownloadModeloArquivoBtn } from 'components/buttons';
import { BbarForm } from 'components/docked/BbarForm';
import { Block } from 'components/page';
import { SubTitle } from 'components/text';
import {
    ConfigPedidoHeaderActions,
    ConfigPedidoImportacaoUploadBtn,
    ConfigPedidoQuebrasDinamicasGrid,
    ConfigPedidoQuebrasDinamicasModal,
    ConfigPedidoRefazerQuebrasModal,
} from 'pages/compra/configuracao-pedido/components/';
import { useLoaderContext } from 'context/LoaderContext';
import { ConfigPedidoListProvider } from 'pages/compra/configuracao-pedido/contexts';
import { useConfigPedidoDirty, useMutateQuebrasDinamicas, useQueryQuebrasDinamicas } from 'pages/compra/configuracao-pedido/hooks';

export function ConfigPedidoQuebrasDinamicasForm() {
    const { id } = useParams();
    const messageRef = useRef('');
    const [openQuebrasModal, setOpenQuebrasModal] = useState(false);
    const [openProdutoQuebraModal, setOpenProdutoQuebraModal] = useState<boolean>(false);

    const { data, isFetching } = useQueryQuebrasDinamicas();
    const { onSubmit, isLoading } = useMutateQuebrasDinamicas({
        setOpenQuebrasModal,
        messageRef,
        initialData: data || { configPedidoQuebrasDinamicas: [] },
    });

    useLoaderContext(isFetching || isLoading);

    const formik = useFormik({
        initialValues: data || { configPedidoQuebrasDinamicas: [] },
        onSubmit,
        enableReinitialize: true,
    });

    const { values, setFieldValue, submitForm, dirty } = formik;

    useConfigPedidoDirty(dirty);

    /**
     * Remove os produtos selecionados do grid.
     */
    const removeProduct = (idList: Set<GridRowId>) => {
        const idListFormatted = Array.from(idList).map((item) => {
            const [idProduto, nrQuebra] = (item as string).split('_');

            return { idProduto: Number(idProduto), nrQuebra: Number(nrQuebra) };
        });

        const filtered = values.configPedidoQuebrasDinamicas.filter((p) => {
            return !idListFormatted.some((item) => p.produto.idProduto === item.idProduto && p.nrQuebra === item.nrQuebra);
        });

        const formatted = filtered.map((p) => {
            idListFormatted.forEach(({ idProduto, nrQuebra }) => {
                if (p.produto.idProduto === idProduto) {
                    if (p.qtQuebra) p.qtQuebra = --p.qtQuebra;
                    if (p.nrQuebra && p.nrQuebra > nrQuebra) p.nrQuebra = --p.nrQuebra;
                }
            });

            return p;
        });

        setFieldValue('configPedidoQuebrasDinamicas', formatted);
    };

    return (
        <FormikProvider value={formik}>
            <ConfigPedidoQuebrasDinamicasModal open={openProdutoQuebraModal} setOpen={setOpenProdutoQuebraModal} />

            <ConfigPedidoRefazerQuebrasModal open={openQuebrasModal} setOpen={setOpenQuebrasModal} message={messageRef.current} />

            <Block>
                <SubTitle label="Importar quebras" />

                <Grid container sx={{ justifyContent: 'space-between', gap: 2, width: '100%' }}>
                    <Grid>
                        <ConfigPedidoImportacaoUploadBtn
                            contentListName="produtoQuebraList"
                            url={`gestao/configpedidoquebra/upload/${id}`}
                            onSuccessUploadFile={(value) => setFieldValue('configPedidoQuebrasDinamicas', value)}
                        />
                    </Grid>

                    <Grid>
                        <DownloadModeloArquivoBtn dsChave="URL_ARQUIVO_MODELO_QUEBRA_DINAMICA_CONFIG_PEDIDO" />
                    </Grid>
                </Grid>
            </Block>

            <ConfigPedidoListProvider
                onAdd={() => setOpenProdutoQuebraModal(true)}
                onRemove={removeProduct}
                searchPlaceholder="Código ou nome do produto..."
            >
                <Block>
                    <SubTitle label="Produtos" />

                    <ConfigPedidoHeaderActions />

                    <ConfigPedidoQuebrasDinamicasGrid handleExcluir={removeProduct} />
                </Block>
            </ConfigPedidoListProvider>

            <BbarForm submitForm={submitForm} />
        </FormikProvider>
    );
}
